import {
  REMOVE_ENDPOINT,
  UPLOAD_ENDPOINT,
  FILE_UPLOAD_ELEMENTS_IDS,
} from '../../consts';

import { initializeInstantFileUploaders } from '../../components/file_uploader';

import {
  defaultDatepickerOptions,
  initializeDatepicker,
} from '../../components/datepicker';

const CONTAINER = '#auction-registration-your-documents';

const CSRF_TOKEN_ELEMENT = '#your-documents-csrf-token';

$(() => {
  const ownershipFormCheckbox = $('#ownership-checkbox');
  const managementFormCheckbox = $('#management-checkbox');
  const managementStructureIdSection = $('#management-structure-id');
  const declarationOfOwnershipSection = $('#declaration-of-ownership-id');

  if (ownershipFormCheckbox.val() === 'False') {
    declarationOfOwnershipSection.hide();
    ownershipFormCheckbox.prop('checked', true);
  }

  if (managementFormCheckbox.val() === 'False') {
    managementStructureIdSection.hide();
    managementFormCheckbox.prop('checked', true);
  }

  const onOwnershipCheckboxChange = () => {
    if (ownershipFormCheckbox.prop('checked')) {
      ownershipFormCheckbox.val('True');
      declarationOfOwnershipSection.hide();
    } else {
      ownershipFormCheckbox.val('False');
      declarationOfOwnershipSection.show();
    }
  };

  const onManagementCheckboxChange = () => {
    if (managementFormCheckbox.prop('checked')) {
      managementFormCheckbox.val('True');
      managementStructureIdSection.hide();
    } else {
      managementFormCheckbox.val('False');
      managementStructureIdSection.show();
    }
  };

  initializeInstantFileUploaders({
    elementsIds: FILE_UPLOAD_ELEMENTS_IDS,
    container: CONTAINER,
    csrfTokenElement: CSRF_TOKEN_ELEMENT,
    uploadEndpoint: UPLOAD_ENDPOINT,
    removeEndpoint: REMOVE_ENDPOINT,
    isMakeAnOfferFile: false,
  });

  const photoDateField = $('[name="photo_date"]').get(0);
  if (photoDateField) {
    initializeDatepicker(photoDateField, {
      ...defaultDatepickerOptions,
      maxDate: null,
      minDate: photoDateField.getAttribute('min-date') || null,
    });
  }

  const addressDateField = $('[name="address_date"]').get(0);
  if (addressDateField) {
    initializeDatepicker(addressDateField, {
      ...defaultDatepickerOptions,
      maxDate: addressDateField.getAttribute('max-date') || null,
      minDate: addressDateField.getAttribute('min-date') || null,
    });
  }

  ownershipFormCheckbox.on('change', onOwnershipCheckboxChange);
  managementFormCheckbox.on('change', onManagementCheckboxChange);
});
